import { createSelector } from '@reduxjs/toolkit';

import { carsApi } from '@/features/cars/reducer';
import carsSelector from '@/features/cars/selectors/cars';

import parametersSelector from './parameters';

/**
 * Получить результат запроса на получение автомобилей из избранного
 */
const favoritesDataSelector = createSelector(
  [carsSelector, parametersSelector],
  (cars, parameters) => {
    return carsApi.endpoints.getCars.select(parameters)({
      cars,
    });
  },
);

export default favoritesDataSelector;
